class StickyAtc {
  constructor() {
    this.el = document.querySelector('[data-sticky-atc]');
    if (!this.el) return;
    this.addBtn = this.el.querySelector('[data-sticky-add]');
    this.priceEl = this.el.querySelector('[data-sticky-price]');
    this.thumbEl = this.el.querySelector('[data-sticky-img]');
    this.submit = document.querySelector('[data-dm-reserve-main]') || document.querySelector('.dm-reserve__button')
      || document.querySelector('[id^="ProductSubmitButton"]');
    this.moneyFormat = this.el.dataset.moneyFormat;
    this.init();
  }

  init() {
    if (!this.addBtn || !this.submit) return;

    // checkout 模式:吸底按钮是 <button>,代理主表单提交(继承变体与 cart-drawer 行为);
    // reserve 模式:吸底按钮是 Instagram 私信深链 <a>,原生跳转,无需代理。
    if (this.addBtn.tagName === 'BUTTON') {
      this.addBtn.addEventListener('click', () => this.submit.click());
    }

    // 变体同步：更新吸底栏价格/缩略图
    if (typeof subscribe === 'function') {
      subscribe('variant-change', (event) => {
        const variant = event && event.data && event.data.variant;
        if (!variant) return;
        if (this.priceEl && variant.price) {
          const money = window.Shopify && Shopify.formatMoney
            ? Shopify.formatMoney(variant.price, this.moneyFormat)
            : '';
          if (money) this.priceEl.textContent = money;
        }
        if (this.thumbEl && variant.featured_media && variant.featured_media.src) {
          this.thumbEl.src = variant.featured_media.src;
        }
      });
    }

    // 滚动越过主加购按钮后显示
    this.drawerOpen = false;
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const show = !entry.isIntersecting && window.scrollY > 160 && !this.drawerOpen;
          this.el.classList.toggle('is-visible', show);
          this.el.setAttribute('aria-hidden', String(!show));
          document.body.classList.toggle('sticky-atc-shown', show);
        });
      }, { rootMargin: '0px 0px -80px 0px', threshold: 0 });
      io.observe(this.submit);
    }

    // PDP policy drawer (pdp-policy-drawer.liquid) covers the viewport —
    // hide the sticky bar while it is open so the two never overlap.
    document.addEventListener('dorje:drawer', (event) => {
      this.drawerOpen = !!(event.detail && event.detail.open);
      if (this.drawerOpen) {
        this.el.classList.remove('is-visible');
        this.el.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('sticky-atc-shown');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new StickyAtc());
